const dev = {
  API_ENDPOINT_LAMBDA: "http://localhost:5000",
  API_ENDPOINT_RAIDMACHINE: "https://localhost:7230/api",
  API_ENDPOINT_STORE: "http://localhost:5069",
  API_ENDPOINT_TWITCH: "https://localhost:7142/",
  API_ENDPOINT_ACCOUNT_MANAGER: "http://localhost:5000",
  API_ENDPOINT_GAME_STATS: "http://localhost:5001",
};

const prod = {
  API_ENDPOINT_LAMBDA: process.env.REACT_APP_API_ENDPOINT_LAMBDA_DASHBOARD,
  API_ENDPOINT_RAIDMACHINE: process.env.REACT_APP_API_ENDPOINT_BACK_RAIDMACHINE,
  API_ENDPOINT_STORE: process.env.REACT_APP_API_ENDPOINT_LAMBDA_STORE,
  API_ENDPOINT_TWITCH: process.env.REACT_APP_API_ENDPOINT_TWITCH,
  API_ENDPOINT_ACCOUNT_MANAGER: process.env.REACT_APP_API_ENDPOINT_ACCOUNT_MANAGER,
  API_ENDPOINT_GAME_STATS: process.env.REACT_APP_API_ENDPOINT_GAME_STATS,
};

const test = {
  API_ENDPOINT_LAMBDA: "https://api.test.com",
  API_ENDPOINT_RAIDMACHINE: "https://goiabada.tapiocahut.com/api",
  API_ENDPOINT_ACCOUNT_MANAGER: "http://localhost:5000",
  API_ENDPOINT_GAME_STATS: "http://localhost:5001",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
